import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { FP_ENDPOINTS } from 'apps/fleet-planner/config'
import { DriverStatusType, IDriver } from 'apps/fleet-planner/types'

export const CREATE_DRIVER_ACTION_TYPES = generateApiActionTypes('CREATE_DRIVER')

export const addNewDriver = (driver: IDriver) => ({
  payload: {
    callApi: true,
    requestData: {
      endpoint: FP_ENDPOINTS.drivers,
      method: 'POST',
      body: {
        ...driver,
        status: DriverStatusType.active,
      },
    },
    actionTypes: Object.keys(CREATE_DRIVER_ACTION_TYPES),
  },
  type: '',
})
